import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { isCertified, isInProgress } from '../../../utility/coachCertification'
import PriceCardCertified from './PriceCardCertified'
import PriceCardProgress from './PriceCardProgress'
import PriceCardPurchase from './PriceCardPurchase'

import classes from './PriceCard.module.scss'

const PriceCard = ({ certification }) => {
  const { t } = useTranslation()
  const { finalQuiz } = certification
  const certifiedState = isCertified(certification)

  return (
    <aside className={classes.card}>
      <span className={classes.eyebrow}>{t('portal.certification.priceCard.level', { level: certification.level })}</span>

      {certifiedState && <PriceCardCertified certification={certification} />}
      {!certifiedState && isInProgress(certification) && <PriceCardProgress certification={certification} />}
      {!certifiedState && !isInProgress(certification) && <PriceCardPurchase certification={certification} />}

      <dl className={`mb-0 ${classes.facts}`}>
        <div className='d-flex justify-content-between'>
          <dt>{t('portal.certification.priceCard.access')}</dt>
          <dd>{t('portal.certification.priceCard.ongoing')}</dd>
        </div>
        <div className='d-flex justify-content-between'>
          <dt>{t('portal.certification.priceCard.retakes')}</dt>
          <dd>
            {finalQuiz?.maxAttempts
              ? t('portal.certification.priceCard.attempts', { count: finalQuiz.maxAttempts })
              : t('portal.certification.priceCard.unlimited')}
          </dd>
        </div>
      </dl>
    </aside>
  )
}

PriceCard.propTypes = {
  certification: PropTypes.shape({
    level: PropTypes.number.isRequired,
    finalQuiz: PropTypes.shape({ maxAttempts: PropTypes.number }),
  }).isRequired,
}

export default PriceCard
